import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { RequisitionData } from '../models/requisition.model';

@Injectable({
    providedIn: 'root'
})
export class RequisitionService {

    constructor(private readonly http: HttpClient) { }

    postSaveRequisition(data: RequisitionData): Observable<number[]> {
        return this.http.post<number[]>(`${environment.backendUrl}/requisition/saverequisition`, data);
    }
}
